/* @flow */
import createDebugger from 'debug';
const debug = createDebugger('app:modules:subscription-management:actions'); // eslint-disable-line no-unused-vars

import type { RawOptions } from './types.js';
import {
  FETCH_TEMPLATES,
  FETCH_SUBSCRIPTIONS,
  FETCH_COMPANY_SUBSCRIPTIONS,
  ACTIVATE,
  EMAIL_ACTIVATE,
  SET_DISPLAY_OPTIONS,
  ADMIN_UNSUBSCRIBE,
} from './action-types.js';

/**
 * Fetch all templates in the system
 * Used by TruSTAR Admins to manage subscriptions on Marketplace.
 */
export const fetchTemplates = () => ({ type: FETCH_TEMPLATES });

/**
 * Fetch all pending and active subscriptions for companies.
 * Used by TruSTAR Admins to manage subscriptions on Marketplace.
 */
export const fetchSubscriptions = () => ({ type: FETCH_SUBSCRIPTIONS });


export const fetchSubscriptionsByCompany = (companyGuid: string) => ({
  type: FETCH_COMPANY_SUBSCRIPTIONS,
  payload: {
    companyGuid
  }
});

/**
 * Activate the subscription for the given enclave and company.
 * Used by TruSTAR Admins to activate credential subscriptions
 * on Marketplace.
 */
export const activate = (enclaveGuid: string, companyGuid: string) => ({
  type: ACTIVATE,
  payload: {
    enclaveGuid,
    companyGuid,
  },
});

/**
 * Send email activation notice for the given enclave and company.
 * Used by TruSTAR Admins to activate credential subscriptions
 * on Marketplace.
 */
export const emailActivate = (enclaveGuid: string, companyGuid: string) => ({
  type: EMAIL_ACTIVATE,
  payload: {
    enclaveGuid,
    companyGuid,
  },
});

/**
 * Similar functionality to regular unsubscribe but this one is only available to admins who have access
 * to subscription management
 */
export const adminUnsubscribe = (feedGuid: string, companyGuid: string, requiredState: string) => ({
  type: ADMIN_UNSUBSCRIBE,
  payload: {
    feedGuid,
    companyGuid,
    requiredState,
  }
});

/**
 * Set display options. Determines sorting and filtering of Subscriptions.
 */
export const setDisplayOptions = (options: RawOptions): Object => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options,
});



// WEBPACK FOOTER //
// ./src/app/modules/subscription-management/actions.js